module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('span', [_c('i', [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("In loving memory of Rudolph Byrd")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1a"
  }, [_c('span', [_c('span', [_c('i', [_vm._v("so deeply missed")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1a"
  }, [_c('span', [_c('span', [_c('i', [_vm._v("and of the miracle that was our trust.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_c('span', [_c('i', [_vm._v("And for G. Kaleo Larson")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1a"
  }, [_c('span', [_c('span', [_c('i', [_vm._v("My working-class hero.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33fb8f6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 72
// module chunks = 0